var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"empty-content flex-container flex-column flex-horiz-center"},[_c('img',{staticClass:"pic",attrs:{"src":_vm.img,"alt":""}}),_c('span',{staticClass:"text"},[_vm._v(_vm._s(_vm.text))])])}
var staticRenderFns = []

export { render, staticRenderFns }